import { HttpBellNotificationAdapter } from '@adapter/notification/http-bell-notification.adapter';
import { BellNotificationGateway } from '@service/notification/bell-notification.gateway';
import { BellNotificationService } from '@service/notification/bell-notification.service';

const getBellNotificationGatewayProvider = {
  provide: BellNotificationGateway,
  useClass: HttpBellNotificationAdapter
};

export const getBellNotificationDi = [
  getBellNotificationGatewayProvider,
  BellNotificationService
];
